import React, {useEffect, useState} from 'react';
import './hac-navigation.scss';
import {useTranslation} from 'react-i18next';
import {HAC_STATUS, ROLES} from '../../../../constants/constants.js';
import decodeToken from "../../../../utils/decode-token";
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {getHacData} from "../../../../api/hacApi";
import {Alert} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { isAdminRole, isPmaRole, isRetailerRole } from '../../../../utils/role-utils';

function HacNavigation() {
  const {t} = useTranslation();
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;

  const {hacId} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {breadcrumbName} = location.state || {};

  const [profileStatus, setProfileStatus] = useState(HAC_STATUS.Nominated);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const navigateTo = (path) => {
    navigate(path, {
      state: {...location.state, breadcrumbName},
    });
  };

  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path;
  const isAdmin = isAdminRole(role);
  const isPma = isPmaRole(role);
  const isRetailer = isRetailerRole(role);

  const nominatingRetailerPath =
    isAdmin
      ? `/admin/nominating-retailer/${hacId}`
      : `/pma/retailer-info/${hacId}`;

  const assignedPmaPath =
    isAdmin || isRetailer
      ? `/admin/assigned-pmas/${hacId}`
      : `/pma/pma-info/${hacId}`;

  const surveysPath =
    isAdmin
      ? `/admin/surveys/${hacId}`
      : isPma
        ? `/pma/surveys/${hacId}`
        : null;

  const sharedNotesPath =
    isAdmin
      ? `/admin/shared-notes/${hacId}`
      : isPma
        ? `/pma/shared-notes/${hacId}`
        : `/retailer/shared-notes/${hacId}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHacData(token, hacId);

        setProfileStatus(response.data.status);
        if (response.status !== 200) throw new Error('Error getting hac data');
        setProfileStatus(response.data.status);

      } catch (error) {
        if (error.response) {
          setSnackbarOpen(true);
          setSnackbarSeverity('error');
          setSnackbarMessage(t('common-internal-server-error'), error);
        }
      }
    };
    fetchData();
  }, [t, token, hacId]);

  return (
    <aside className="lateral-menu">
      <h2>{t('common-profile')}</h2>
      <ul>
        <li className={isActive(`/common/personal-details/${hacId}`) ? 'on' : ''}>
          <a href="/common/personal-details/" onClick={(e) => {
            e.preventDefault();
            navigateTo(`/common/personal-details/${hacId}`);
          }}>
            {t('admin-main-tab1-option1')}
          </a>
        </li>

        {profileStatus !== HAC_STATUS.Nominated && (
          <>
            <li className={isActive(`/common/vehicles/${hacId}`) ? 'on' : ''}>
              <a href="/common/vehicles/" onClick={(e) => {
                e.preventDefault();
                navigateTo(`/common/vehicles/${hacId}`);
              }}>
                {t('admin-main-tab1-option2')}
              </a>
            </li>

            <li className={isActive(`/common/preferences/${hacId}`) ? 'on' : ''}>
              <a href="/common/preferences" onClick={(e) => {
                e.preventDefault();
                navigateTo(`/common/preferences/${hacId}`);
              }}>
                {t('admin-main-tab1-option3')}
              </a>
            </li>
          </>
        )}


        {(isAdmin || isPma) && (
         
            <li className={isActive(nominatingRetailerPath) ? 'on' : ''}>
              <a href="/nominating-reatiler" onClick={(e) => {
                e.preventDefault();
                navigateTo(nominatingRetailerPath);
              }}>
                {t('admin-main-tab1-option4')}
              </a>
            </li>
        )}
        {[ROLES.Retailer, ROLES.RetailerGM].includes(role) && (
         
            <li className={isActive(assignedPmaPath) ? 'on' : ''}>
              <a href="/assigned-pma" onClick={(e) => {
                e.preventDefault();
                navigateTo(assignedPmaPath);
              }}>
                {t('admin-main-tab1-option5')}
              </a>
            </li>
        )}
        {(isAdmin || isPma) && (
            <>
            <li className={isActive(`/common/activity-log/${hacId}`) ? 'on' : ''}>
              <a href="/common/activity-log" onClick={(e) => {
                e.preventDefault();
                navigateTo(`/common/activity-log/${hacId}`);
              }}>
                {t('pma-hac-tab-option8')}
              </a>
            </li>
          </>
        )}

        {![ROLES.Retailer, ROLES.RetailerGM].includes(role) && (
          <li className={isActive(surveysPath) ? 'on' : ''}>
            <a href="/surveys" onClick={(e) => {
              e.preventDefault();
              navigateTo(surveysPath);
            }}>
              {t('common-surveys')}
            </a>
          </li>
        )}
        <li className={isActive(sharedNotesPath) ? 'on' : ''}>
          <a href="/shared-notes" onClick={(e) => {
            e.preventDefault();
            navigateTo(sharedNotesPath);
          }}>
            {t('pma-hac-tab-option7')}
          </a>
        </li>

        {isPma && (
          <li className={isActive(`/pma/unenroll/${hacId}`) ? 'on' : ''}>
            <a href="/pma/unenroll" onClick={(e) => {
              e.preventDefault();
              navigateTo(`/pma/unenroll/${hacId}`);
            }}>
              {t('pma-hac-tab-option6')}
            </a>
          </li>
        )}
      </ul>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert severity={snackbarSeverity} sx={{width: '100%'}}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </aside>

  )
    ;
}

export default HacNavigation;
